module.exports = __webpack_public_path__ + "static/img/pic-bg-3.4d86811.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/pic-bg-3.png
// module id = KIS6
// module chunks = 0